import http from '../const/http-common';

class CubeService {
  /**
   * Bulk save cubes with dimension names
   * @param {Object} requestData - The bulk save request data
   * @param {number} requestData.source_id - The source ID
   * @param {Array} requestData.cubes - Array of cube objects with name and dimension_names
   * @returns {Promise} - API response
   */
  async bulkSaveCubes(requestData) {
    try {
      const response = await http.post('/v1/cube/bulk-save', requestData);
      return response.data;
    } catch (error) {
      console.error('Error in bulk save cubes:', error);
      throw error;
    }
  }

  /**
   * Get cubes by source ID
   * @param {number} sourceId - The source ID
   * @param {number} page - Page number (default: 1)
   * @param {number} pageSize - Page size (default: 10)
   * @returns {Promise} - API response
   */
  async getCubesBySource(sourceId, page = 1, pageSize = 10) {
    try {
      const response = await http.get(`/v1/cube/source/${sourceId}`, {
        params: { page, page_size: pageSize }
      });
      return response.data;
    } catch (error) {
      console.error('Error getting cubes by source:', error);
      throw error;
    }
  }

  /**
   * Get all cubes with pagination
   * @param {number} page - Page number (default: 1)
   * @param {number} pageSize - Page size (default: 10)
   * @returns {Promise} - API response
   */
  async getCubes(page = 1, pageSize = 10) {
    try {
      const response = await http.get('/v1/cube/', {
        params: { page, page_size: pageSize }
      });
      return response.data;
    } catch (error) {
      console.error('Error getting cubes:', error);
      throw error;
    }
  }

  /**
   * Get cube by ID
   * @param {number} cubeId - The cube ID
   * @returns {Promise} - API response
   */
  async getCube(cubeId) {
    try {
      const response = await http.get(`/v1/cube/${cubeId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting cube:', error);
      throw error;
    }
  }

  /**
   * Create a single cube
   * @param {Object} cubeData - The cube data
   * @returns {Promise} - API response
   */
  async createCube(cubeData) {
    try {
      const response = await http.post('/v1/cube/', cubeData);
      return response.data;
    } catch (error) {
      console.error('Error creating cube:', error);
      throw error;
    }
  }

  /**
   * Update a cube
   * @param {number} cubeId - The cube ID
   * @param {Object} cubeData - The updated cube data
   * @returns {Promise} - API response
   */
  async updateCube(cubeId, cubeData) {
    try {
      const response = await http.put(`/v1/cube/${cubeId}`, cubeData);
      return response.data;
    } catch (error) {
      console.error('Error updating cube:', error);
      throw error;
    }
  }

  /**
   * Delete a cube
   * @param {number} cubeId - The cube ID
   * @returns {Promise} - API response
   */
  async deleteCube(cubeId) {
    try {
      const response = await http.delete(`/v1/cube/${cubeId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting cube:', error);
      throw error;
    }
  }
}

export default new CubeService();
